export const featureAccess = {
    institutionsGroupAccess: false, // TODO move this setting to groupsManagement
    translationAccess: {
        show: false,
        withFlag: false
    },
};